import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteAutomation } from '@/services/dmAutomation.service';
import { queryKeys } from '@/hooks/queries/keys';

export const useDeleteAutomation = () => {
    const queryClient = useQueryClient();
    return useMutation<void, unknown, string>({
        mutationFn: (id) => deleteAutomation(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.dmAutomation.list() });
            queryClient.invalidateQueries({ queryKey: queryKeys.dmAutomation.statsOverview() });
        },
    });
};
